import { Skeleton } from "@mui/material";
import Carousel from "../../components/Carousel";
import PlaceholderFade from "../../components/PlaceholderFade";
import PosterTile from "../../components/PosterTile";
import { useDetailNavigation } from "../../hooks/useDetailNavigation";
import { useInProgress } from "../../hooks/useCustomQuery";
import {
  getContentNoun,
  getStatusOptions,
  getTimeAgo,
  getTrackPath,
} from "../../utils/utils";
import { SLOT_SX } from "./ProfileStandouts";

// useInProgress fetches this many; beyond it the row ends with a "See all" card
const ROW_LIMIT = 10;

/**
 * Dashboard "On the go": everything you've started, most recently started
 * first, each captioned with when it was started. "See all" opens the Track
 * page's started tab for the selected type (or All). Hidden when empty — the
 * dashboard leaves it out then (see Profile).
 */
export default function DashboardInProgress({ username, contentType }) {
  const { data, isLoading, isPlaceholderData } = useInProgress(
    username,
    contentType,
  );
  const { openContent } = useDetailNavigation();

  if (isLoading) {
    return (
      <Skeleton variant="rectangular" height={180} sx={{ borderRadius: 1 }} />
    );
  }
  if (!data || data.items.length === 0) return null;

  return (
    <PlaceholderFade active={isPlaceholderData}>
      <Carousel
        title="On the go"
        // The started status's own icon and colour, as on the Track page
        titleIcon={getStatusOptions().started.iconFilled}
        description={`${data.total} ${getContentNoun({ type: contentType, plural: data.total !== 1 })} currently started`}
        items={data.items}
        getItemKey={(item) => item.content_id}
        itemSx={SLOT_SX}
        renderItem={(item) => (
          <PosterTile
            contentId={item.content_id}
            contentType={item.content_type}
            contentTitle={item.content_title}
            imageUrl={item.image_url}
            overlay={true}
            // The All view mixes types, so mark each poster's type
            showType={contentType === "all"}
            onClick={() =>
              openContent({
                contentId: item.content_id,
                contentType: item.content_type,
                title: item.content_title,
              })
            }
          />
        )}
        renderCaption={(item) =>
          getTimeAgo(item.status_timestamp, { short: true })
        }
        seeMoreLink={getTrackPath(username, contentType, "started")}
        showSeeMoreCard={data.total > ROW_LIMIT}
      />
    </PlaceholderFade>
  );
}
